import '../styles.scss'

import { useTranslation } from 'react-i18next'

import B2BecLink from '@/components/B2BLink'

const UpperSectionComponent = ({ salesOrderNumber }) => {
  const { t } = useTranslation()

  return (
    <div className="order-confirm__main__upper">
      <span className="order-confirm__main__upper--main-text">
        {t('checkout.confirmOrder.yourOrderNumberWasSuccessfullyPlaced', {
          orderNumber: salesOrderNumber,
        })}
        !
      </span>
      <div className="order-confirm__main__upper--sub-text">
        {t('checkout.confirmOrder.YourOrderIsBeingProcessed')}
        &nbsp;
        <B2BecLink
          state={{ currentPage: 1 }}
          to={`/orders/${salesOrderNumber}`}
        >
          {t('checkout.confirmOrder.seeOrderDetails')}
        </B2BecLink>
      </div>
    </div>
  )
}
export default UpperSectionComponent
